import type { DealPromptDomainsConfig } from '@openx/components-deal-prompt/lib/utils/context/type';
import { useDealPromptAppsSearchExtendedFetch } from './utils/useDealPromptAppsSearchExtendedFetch';
import { useDealPromptAppsSearchFetch } from './utils/useDealPromptAppsSearchFetch';
import { useDealPromptAudienceAccountOptions } from './utils/useDealPromptAudienceAccountOptions';
import { useDealPromptAudienceCalculateOrf } from './utils/useDealPromptAudienceCalculateOrf';
import { useDealPromptAudienceCreateDealSubmit } from './utils/useDealPromptAudienceCreateDealSubmit';
import { useDealPromptAudienceExcelGenerate } from './utils/useDealPromptAudienceExcelGenerate';
import { useDealPromptAudienceExternalPartnerWithData } from './utils/useDealPromptAudienceExternalPartnerWithData';
import { useDealPromptAudienceSearchFetch } from './utils/useDealPromptAudienceSearchFetch';
import { useDealPromptAudienceSearchTextFetch } from './utils/useDealPromptAudienceSearchTextFetch';
import { useDealPromptCountryOptions } from './utils/useDealPromptCountryOptions';
import { useDealPromptDataPartnerOptions } from './utils/useDealPromptDataPartnerOptions';
import { useDealPromptDomainSearchExtendedFetch } from './utils/useDealPromptDomainSearchExtendedFetch';
import { useDealPromptDomainSearchFetch } from './utils/useDealPromptDomainSearchFetch';
import { useDealPromptFilters } from './utils/useDealPromptFilters';
import { useDealPromptLocationOptions } from './utils/useDealPromptLocationOptions';
import { useDealPromptOrganizationsList } from './utils/useDealPromptOrganizationsList';
import { useDealPromptPricing } from './utils/useDealPromptPricing';
import { useDealPromptRegionOptions } from './utils/useDealPromptRegionOptions';
import { useDealPromptTaxonomyMetadataOptions } from './utils/useDealPromptTaxonomyMetadataOptions';

export const dealPromptConfig: DealPromptDomainsConfig = {
  useDealPromptDomainSearchFetch,
  useDealPromptFilters,
  useDealPromptAppsSearchFetch,
  useDealPromptAudienceSearchTextFetch,
  useDealPromptLocationOptions,
  useDealPromptRegionOptions,
  useDealPromptCountryOptions,
  useDealPromptDataPartnerOptions,
  useDealPromptAudienceAccountOptions,
  useDealPromptTaxonomyMetadataOptions,
  useDealPromptAudienceExternalPartnerWithData,
  useDealPromptAudienceExcelGenerate,
  useDealPromptAppsSearchExtendedFetch,
  useDealPromptDomainSearchExtendedFetch,
  useDealPromptAudienceSearchFetch,
  useDealPromptAudienceCalculateOrf,
  useDealPromptPricing,
  useDealPromptOrganizationsList,
  useDealPromptAudienceCreateDealSubmit,
};
